export const previewFeatures = [
    {
        key: 'content-governance',
        label: 'Requests',
        description: 'Content governance requests and review workflows.',
    },
] as const;

export type PreviewFeatureKey = typeof previewFeatures[number]['key'];

export type PreviewFeatureEntry = {
    id?: string | null;
    type?: string | null;
    ownerId?: string | null;
    sharedById?: string | null;
};

export const previewFeatureScopeId = 'SystemPreviewFeatures';

export const getPreviewFeatureType = (key: PreviewFeatureKey) => `PreviewFeature:${key}`;

export const hasPreviewFeature = (
    entries: Array<PreviewFeatureEntry | null> | null | undefined,
    userId: string | null | undefined,
    key: PreviewFeatureKey,
) => {
    if (!userId) return false;

    return entries?.some(entry =>
        entry?.type === getPreviewFeatureType(key)
        && entry.ownerId === previewFeatureScopeId
    ) ?? false;
};